import { type ComponentType } from 'react';
import { type ModalProps as DirectModalProps } from '@direct-frontend/components';
import { getPlatformComponent } from '@direct-frontend/platform-code';
import { type ModalProps } from './types';

export { DEFAULT_PREVENT_SCROLL } from './constants';

export const Modal = getPlatformComponent<ComponentType<DirectModalProps & ModalProps>>({
    desktop: import('./Modal@desktop'),
    mobile: import('./Modal@mobile'),
});
